export default __webpack_public_path__ + "static/media/bg.b734ddb3.svg";